import React from 'react'
import ErrorImage from './Assets/Images/404-error1.png'
import { Typography, Button, Container, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'

const Error404 = () => {
  const theme = useTheme()
  return (
    <Container
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        height: 'auto',
      }}
    >
      <Typography
        component="img"
        src={ErrorImage}
        alt="404 Error"
        sx={{ width: '100%', maxWidth: '200px' }}
      />
      <Typography
        component="h5"
        variant="h4"
        sx={{
          color: theme.palette.text.main,
        }}
      >
        Oops! Something Went Wrong :)
      </Typography>
      <Typography
        component="body1"
        sx={{
          fontSize: '1rem',
          marginBottom: '2rem',
          color: theme.palette.text.paragraph,
        }}
      >
        The page you are looking for might have been moved or does not exist.
      </Typography>
      <div className="mb-5 p-2">
        <Button
          component={Link}
          to="/"
          variant="contained"
          sx={{
            margin: '0.5rem',
            backgroundColor: theme.palette.background.primaryBackground,
          }}
        >
          Go to Home
        </Button>
        <Button
          component={Link}
          to="/contactus"
          variant="outlined"
          color="primary"
          sx={{ margin: '0.5rem' }}
        >
          Contact Us
        </Button>
      </div>
    </Container>
  )
}

export default Error404
